export default __webpack_public_path__ + "static/media/leo.0c4e39f9.png";